export const SET_ACCOUNT = 'SET_ACCOUNT';

export const SET_APP_AUTHENTICATION = 'SET_APP_AUTHENTICATION';

export const SET_ARTICLE = 'SET_ARTICLE';
export const SET_ARTICLES = 'SET_ARTICLES';

export const SET_BELIEF_STATEMENTS = 'SET_BELIEF_STATEMENTS';

export const SET_CHANNEL = 'SET_CHANNEL';
export const SET_CHANNELS = 'SET_CHANNELS';

export const SET_DRAWER = 'SET_DRAWER';

export const APPEND_EPISODES = 'APPEND_EPISODES';
export const SET_EPISODE = 'SET_EPISODE';
export const SET_EPISODES = 'SET_EPISODES';
export const SET_EPISODES_AGGREGATIONS = 'SET_EPISODES_AGGREGATIONS';
export const SET_EPISODES_PAGINATION_FIELD = 'SET_EPISODES_PAGINATION_FIELD';

export const APPEND_EPISODE_COLLECTIONS = 'APPEND_EPISODE_COLLECTIONS';
export const SET_EPISODE_COLLECTION = 'SET_EPISODE_COLLECTION';
export const SET_EPISODE_COLLECTIONS = 'SET_EPISODE_COLLECTIONS';
export const SET_EPISODE_COLLECTIONS_PAGINATION_FIELD = 'SET_EPISODE_COLLECTIONS_PAGINATION_FIELD';

export const SET_EVENT = 'SET_EVENT';
export const SET_EVENTS = 'SET_EVENTS';

export const ADD_EVENT_REGISTRATION_PARTICIPANT = 'ADD_EVENT_REGISTRATION_PARTICIPANT';
export const SET_EVENT_REGISTRATION = 'SET_EVENT_REGISTRATION';
export const SET_EVENT_REGISTRATION_FIELD = 'SET_EVENT_REGISTRATION_FIELD';
export const SET_EVENT_REGISTRATION_FIELDS = 'SET_EVENT_REGISTRATION_FIELDS';
export const SET_EVENT_REGISTRATION_PARTICIPANT_FIELD = 'SET_EVENT_REGISTRATION_PARTICIPANT_FIELD';
export const SET_EVENT_REGISTRATION_PARTICIPANTS = 'SET_EVENT_REGISTRATION_PARTICIPANTS';
export const REMOVE_EVENT_REGISTRATION_PARTICIPANT = 'REMOVE_EVENT_REGISTRATION_PARTICIPANT';

export const SET_PAGE = 'SET_PAGE';

export const SET_MEMBER = 'SET_MEMBER';
export const UNSET_MEMBER = 'UNSET_MEMBER';

export const SET_MINISTRY = 'SET_MINISTRY';
export const SET_MINISTRIES = 'SET_MINISTRIES';

export const SET_SERVICES = 'SET_SERVICES';
export const SET_SERVICES_FILTER = 'SET_SERVICES_FILTER';
export const SET_SERVICES_FILTER_DEFAULTS = 'SET_SERVICES_FILTER_DEFAULTS';
export const SET_SERVICES_MODE = 'SET_SERVICES_MODE';
export const SET_SERVICES_NEXT_PAGE = 'SET_SERVICES_NEXT_PAGE';
export const SET_SERVICES_REFRESH = 'SET_SERVICES_REFRESH';
export const TOGGLE_SERVICES_FILTER = 'TOGGLE_SERVICES_FILTER';

export const APPEND_SPEAKERS = 'APPEND_SPEAKERS';
export const SET_SPEAKER = 'SET_SPEAKER';
export const SET_SPEAKERS = 'SET_SPEAKERS';
export const SET_SPEAKERS_PAGINATION_FIELD = 'SET_SPEAKERS_PAGINATION_FIELD';

export const SET_STAFF_MEMBER = 'SET_STAFF_MEMBER';
export const SET_STAFF_MEMBERS = 'SET_STAFF_MEMBERS';

export const SET_ORDER = 'SET_ORDER';

export const SET_WAIVER = 'SET_WAIVER';
